module.exports = __webpack_public_path__ + "static/moolah-7cad30be2c7a8f8f014862a27f841170.png";